import { AlertTriangle } from "lucide-react";

import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

// Styles Constants based on Figma Design
const STYLES = {
  errorMessage: {
    fontFamily: '"B Yekan", Tahoma, sans-serif',
    fontSize: "12px",
    lineHeight: "20px",
    color: "#FF0000",
    whiteSpace: "pre-line" as const
  },
  errorText: {
    fontFamily: '"B Yekan", Tahoma, sans-serif',
    fontSize: "12px",
    lineHeight: "20px",
    whiteSpace: "pre-line" as const
  },
  button: {
    width: "108px",
    height: "32px",
    padding: "7px 0",
    background: "#0068B8",
    boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.25)",
    fontFamily: '"B Yekan", Tahoma, sans-serif',
    fontSize: "15px",
    lineHeight: "15px",
    color: "#FFF8F8",
    borderRadius: "4px"
  }
} as const;

const InvalidToken = () => {
  return (
    <div className="w-full space-y-6 sm:space-y-8">
      {/* Error Icon */}
      <div className="flex justify-center">
        <AlertTriangle size={60} color="#FF0404" fill="none" strokeWidth={2} />
      </div>

      {/* Title */}
      <div className="space-y-4">
  
        {/* Error Message */}
        <div className="px-4">
          <p className="" style={STYLES.errorMessage}>
            لینک بازیابی رمز عبور نامعتبر است یا منقضی شده است.
            
                  </p>
                  
                  <p style={STYLES.errorText}>
            لطفاً مجدداً درخواست بازیابی رمز عبور را از طریق صفحه ورود انجام
            دهید.
            {"\n"}
            در صورت ادامه مشکل، با پشتیبانی سامانه تماس حاصل نمایید.
                  </p>
        </div>
      </div>

      {/* Back to Login Button */}
      <div className="flex justify-end">
        <Link to="/dashboard/login">
          <Button
            className="flex items-center justify-center font-normal transition-opacity hover:opacity-90"
            style={STYLES.button}
          >
            بازگشت به ورود
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default InvalidToken;
